module.exports = __webpack_public_path__ + "img/logo_araruna.5377ab88.svg";